import React from 'react';

const Landing = () => {

  return (
    <iframe id="iframe" src="https://ventokredit.amberoon.com/home-page-2025" title="VentoKredit" frameBorder="0" height="100%" width="100%"></iframe>
  );
}

export default Landing;